import Rete from 'rete';
import {v4 as uuid} from 'uuid';
import {tempActionSocket} from "../sockets";
import {StartComponentHelper} from "../extensions/StartComponentHelper";
import {StartNode} from "../nodes/StartNode";

export class StartComponent extends Rete.Component {

    static get COMPONENT_NAME() { return "Start"; };
    static get START_COMPONENT_KEY() { return "StartComponent"; };
    static get START_OUTPUT_KEY() { return "output"; };

    constructor() {
        super(StartComponent.COMPONENT_NAME);
        this.data.component = StartNode;
    }

    builder(node) {
        if (node.componentId === undefined) {
            node.componentId = uuid();
        }

        let startComponentUUID = node.componentId;

        let output = new Rete.Output(
            StartComponentHelper.getStartNodeOutputKey(startComponentUUID),
            "action",
            tempActionSocket,
            false
        );

        return node.addOutput(output);
    }

    worker(node, inputs, outputs) {

    }
}